import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import AbrdnButton from '@/components/Generic/Buttons/AbrdnButton';
import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import { useI18n } from 'next-localization';
import { SCROLL_OFFSET } from 'hooks/useSidebar';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

interface Fields {
  title?: Field<string>;
  cta?: LinkField;
}

type ArticleSubscriptionBannerProps = ComponentProps & {
  fields: Fields;
  params: {
    background?: string;
  };
};

const ArticleSubscriptionBanner: React.FC<ArticleSubscriptionBannerProps> = ({
  fields,
  rendering,
}) => {
  const { backgroundClass } = useHelpers(rendering);
  const {
    sitecoreContext: { pageEditing },
  } = useSitecoreContext();
  const showBanner = (!!fields?.title?.value && !!fields?.cta?.value) || !!pageEditing;
  const { t } = useI18n();
  if (!showBanner) {
    return null;
  }

  const scrollTo = (id: string | undefined) => {
    if (!id) return;
    const element = document.getElementById(id);
    if (element) window.scrollTo({ top: element.offsetTop - SCROLL_OFFSET, behavior: 'smooth' });
  };

  return (
    <section
      data-e2e-component-uid={rendering.uid}
      className={`p-3 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center ${backgroundClass}`}
    >
      <Text tag="p" field={fields.title} className="subheader-1 background-to-change pe-3" />

      <AbrdnButton
        buttonType="primary"
        linkField={fields.cta}
        className="background-to-change flex-shrink-0 mt-3 mt-md-0"
        onClick={() => scrollTo(fields.cta?.value?.anchor)}
      >
        <span>{t('signUp')}</span>
      </AbrdnButton>
    </section>
  );
};

export default ArticleSubscriptionBanner;
